import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import { closeAllPopups, closePopup } from 'src/lib/popups/popupOpenClose';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import PopupMonitor from '../logic/PopupMonitor';

const MATCH2_BUDDIES = 'match2 Buddies';

function closePopupBuddiesBaking() {
  if (!PopupMonitor.isOpen('popupBuddiesBaking')) return;
  closePopup('popupBuddiesBaking', false);
}

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_BUDDIES] = [
    {
      text: 'Reset Buddies',
      color: 'cancel',
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_buddiesReset();
      },
    },
    {
      text: 'Add 2 Strawberries',
      color: 'secondary',
      cheat: async () => {
        closePopupBuddiesBaking();
        await StateObserver.invoke.cheat_buddiesAddScore({ score: 2 });
      },
    },
    {
      text: 'Add 10 Strawberries',
      color: 'secondary',
      cheat: async () => {
        closePopupBuddiesBaking();
        await StateObserver.invoke.cheat_buddiesAddScore({ score: 10 });
      },
    },
    {
      text: 'Add 50 Strawberries',
      color: 'secondary',
      cheat: async () => {
        closePopupBuddiesBaking();
        await StateObserver.invoke.cheat_buddiesAddScore({ score: 50 });
      },
    },
    {
      text: 'Add Dummy Buddy',
      color: 'primary',
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_buddiesAddDummy();
      },
    },
    {
      text: 'Score Buddy 1',
      color: 'secondary',
      cheat: async () => {
        closePopupBuddiesBaking();
        await StateObserver.invoke.cheat_buddiesScoreBuddy({ slot: 1 });
      },
    },
    {
      text: 'Score Buddy 2',
      color: 'secondary',
      cheat: async () => {
        closePopupBuddiesBaking();
        await StateObserver.invoke.cheat_buddiesScoreBuddy({ slot: 2 });
      },
    },
    {
      text: 'Score Buddy 3',
      color: 'secondary',
      cheat: async () => {
        closePopupBuddiesBaking();
        await StateObserver.invoke.cheat_buddiesScoreBuddy({ slot: 3 });
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  switch (args.key) {
    case MATCH2_BUDDIES:
      args.title.updateOpts({
        width: args.item.style.width - 40,
        height: 20,
        y: 8,
        align: 'center',
      });
      args.popup.createVerticalButtons(args.item, args.setting);
      break;
  }
};

export const match2BuddiesCheats = {
  list,
  ui,
};
